<template>
    <div>
        <!-- Info Banner -->
        <div class="form-info-banner">
            <h3 class="form-info-banner-title">Os campos com * são de preenchimento obrigatório</h3>
            <p class="form-info-banner-text">Caso queira, você poderá salvar e continuar depois.</p>
        </div>
        
        <!-- Seção: Endereço Residencial -->
        <section class="form-section">
            <div class="form-section-header">
                <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Endereço residencial'"
                    :Sessao="'Endereço'" :SubSessao="'Endereço residencial'" />
            </div>
            <div class="form-section-content">
                <div class="form-subsection">
                    <h4 class="form-subsection-title">
                        <i class="fa fa-map-marker"></i>
                        Localização
                    </h4>
                    <EnderecoFields
                        ref="residentialAddress"
                        v-model="localPF"
                        :countries="listaPaises"
                        :field-map="residentialAddressFieldMap"
                        id-prefix="pf-residential-address"
                        @change="salvarAlteracoesLocalmente"
                    />
                    <div class="form-grid-1">
                        <div class="form-field">
                            <label class="form-field-label form-field-label-required">Esse endereço é o mesmo de correspondência?</label>
                            <div class="form-radio-group">
                                <label class="form-radio-item">
                                    <input type="radio" value="1" name="EnderecoCorrespondencia" class="form-radio-input"
                                        v-model="localPF.EnderecoCorrespondencia"
                                        @change="salvarAlteracoesLocalmenteLimpandoEnderecoCorrespondencia" />
                                    <span class="form-radio-label">Sim</span>
                                </label>
                                <label class="form-radio-item">
                                    <input type="radio" value="2" name="EnderecoCorrespondencia" class="form-radio-input"
                                        v-model="localPF.EnderecoCorrespondencia" @change="salvarAlteracoesLocalmente" />
                                    <span class="form-radio-label">Não</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        
        <!-- Seção: Endereço de Correspondência (condicional) -->
        <section v-if="localPF.EnderecoCorrespondencia == 2" class="form-section">
            <div class="form-section-header">
                <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Endereço correspondência'"
                    :Sessao="'Endereço'" :SubSessao="'Endereço correspondência'" />
            </div>
            <div class="form-section-content">
                <div class="form-subsection">
                    <h4 class="form-subsection-title">
                        <i class="fa fa-envelope"></i>
                        Localização
                    </h4>
                    <EnderecoFields
                        ref="correspondenceAddress"
                        v-model="localPF"
                        :countries="listaPaises"
                        :field-map="correspondenceAddressFieldMap"
                        id-prefix="pf-correspondence-address"
                        @change="salvarAlteracoesLocalmente"
                    />
                </div>
            </div>
        </section>
        
        <!-- Seção: Endereço Comercial -->
        <section class="form-section">
            <div class="form-section-header">
                <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Endereço comercial'"
                    :Sessao="'Endereço'" :SubSessao="'Endereço comercial'" />
            </div>
            <div class="form-section-content">
                <div class="form-subsection">
                    <h4 class="form-subsection-title">
                        <i class="fa fa-briefcase"></i>
                        Localização
                    </h4>
                    <EnderecoFields
                        ref="commercialAddress"
                        v-model="localPF"
                        :countries="listaPaises"
                        :field-map="commercialAddressFieldMap"
                        :optional="true"
                        id-prefix="pf-commercial-address"
                        @change="salvarAlteracoesLocalmente"
                    />
                </div>
            </div>
        </section>
        
        <ModalAlerta 
            :mostrar="modalAlerta.mostrar"
            :tipo="modalAlerta.tipo"
            :titulo="modalAlerta.titulo"
            :mensagem="modalAlerta.mensagem"
            @fechar="modalAlerta.mostrar = false"
        />
    </div>
</template>

<script>

import { mapGetters } from 'vuex';
import LabelDisclaimer from '@/components/LabelDisclaimer.vue'
import EnderecoFields from '@/components/EnderecoFields.vue';
import ModalAlerta from '../Utilitarios/ModalAlerta.vue';

export default {
    name: 'CadastroPF_Endereco',
    props: ['informacoesBasicas', 'Edicao'],
    components: { LabelDisclaimer, ModalAlerta, EnderecoFields },
    computed: {
        ...mapGetters({
            user: 'auth/user',
            etapaCadastro: 'GET_ETAPA_CADASTRO',
            infoBasicas: 'GET_PF_INFO_BASICAS',
            listaPaises: 'GET_LISTA_PAISES',
        }),
    },
    data() {
        return {
            modalAlerta: {
                mostrar: false,
                tipo: 'warning',
                titulo: '',
                mensagem: ''
            },
            camposObrigatorios: {
                erroEnderecoCep: false,
                erroEnderecoLogradouro: false,
                erroEnderecoNumero: false,
                erroEnderecoBairro: false,
                erroEnderecoCidade: false,
                erroEnderecoUf: false,
                erroEnderecoPais: false,
                erroEnderecoOutroCep: false,
                erroEnderecoOutroLogradouro: false,
                erroEnderecoOutroNumero: false,
                erroEnderecoOutroBairro: false,
                erroEnderecoOutroCidade: false,
                erroEnderecoOutroUf: false,
                erroEnderecoOutroPais: false,
                erroEnderecoComercialCep: false,
                erroEnderecoComercialLogradouro: false,
                erroEnderecoComercialNumero: false,
                erroEnderecoComercialBairro: false,
                erroEnderecoComercialCidade: false,
                erroEnderecoComercialUf: false,
                erroEnderecoComercialPais: false,
            },
            residentialAddressFieldMap: {
                number: 'LogradouroNumero',
                complement: 'LogradouroComplemento',
                country: 'LogradouroPais'
            },
            correspondenceAddressFieldMap: {
                postalCode: 'CepOutro',
                street: 'LogradouroOutro',
                number: 'LogradouroNumeroOutro',
                complement: 'LogradouroComplementoOutro',
                neighborhood: 'BairroOutro',
                city: 'CidadeOutro',
                region: 'UfOutro',
                country: 'PaisOutro'
            },
            commercialAddressFieldMap: {
                postalCode: 'EnderecoComercialCep',
                street: 'EnderecoComercial',
                number: 'EnderecoComercialNumero',
                complement: 'EnderecoComercialComplemento',
                neighborhood: 'EnderecoComercialBairro',
                city: 'EnderecoComercialCidade',
                region: 'EnderecoComercialEstado',
                country: 'EnderecoComercialPais'
            },
            localPF: this.informacoesBasicas,
            permitirAvancar: false,
        }
    },
    mounted() {
        if (this.localPF != null) {
            this.localPF.EnderecoCorrespondencia = this.informacoesBasicas.CepOutro != '' && this.localPF.CepOutro != null ? 2 : 1;
        }
        this.validarFormulario();
    },
    methods: {
        salvarAlteracoesLocalmenteLimpandoEnderecoCorrespondencia() {
            this.localPF.LogradouroOutro = null;
            this.localPF.BairroOutro = null;
            this.localPF.CidadeOutro = null;
            this.localPF.UfOutro = null;
            this.localPF.PaisOutro = null;
            this.localPF.CepOutro = null;
            this.salvarAlteracoesLocalmente();
        },
        proximaEtapa() {
            if (this.validarFormulario(true)) {
                this.$store.commit('SET_ETAPA_CADASTRO', 5);
                this.$store.commit('SET_SALVAR_INFO_DES_NOTIFICACAO', true);
                this.salvarInformacoes();
            }
        },
        salvarInformacoes() {
            this.$store.commit('SET_PF_SALVAR_INFO', true);
        },
        salvarAlteracoesLocalmente() {
            this.$store.commit('SET_PF_SALVAR_INFO_ENDERECO', this.localPF);
            this.validarFormulario(false);
        },
        validarFormulario(submeter) {
            this.permitirAvancar = true;
            var nomeDoCampo = '';
            this.camposObrigatorios = {
                erroEnderecoCep: false,
                erroEnderecoLogradouro: false,
                erroEnderecoNumero: false,
                erroEnderecoBairro: false,
                erroEnderecoCidade: false,
                erroEnderecoUf: false,
                erroEnderecoPais: false,
                erroEnderecoOutroCep: false,
                erroEnderecoOutroLogradouro: false,
                erroEnderecoOutroNumero: false,
                erroEnderecoOutroBairro: false,
                erroEnderecoOutroCidade: false,
                erroEnderecoOutroUf: false,
                erroEnderecoOutroPais: false,
                erroEnderecoComercialCep: false,
                erroEnderecoComercialLogradouro: false,
                erroEnderecoComercialNumero: false,
                erroEnderecoComercialBairro: false,
                erroEnderecoComercialCidade: false,
                erroEnderecoComercialUf: false,
                erroEnderecoComercialPais: false,
            };
            const residentialAddress = this.$refs.residentialAddress?.validate(Boolean(submeter));
            if (!residentialAddress?.valid) {
                if (submeter && this.permitirAvancar) {
                    nomeDoCampo = `${residentialAddress?.firstInvalidLabel || 'País'} do Endereço Principal`;
                }
                this.permitirAvancar = false;
            }

            if (this.localPF.EnderecoCorrespondencia == 2) {
                const correspondenceAddress = this.$refs.correspondenceAddress?.validate(Boolean(submeter));
                if (!correspondenceAddress?.valid) {
                    if (submeter && this.permitirAvancar) {
                        nomeDoCampo = `${correspondenceAddress?.firstInvalidLabel || 'País'} do Endereço de Correspondência`;
                    }
                    this.permitirAvancar = false;
                }
            }

            const commercialAddress = this.$refs.commercialAddress?.validate(Boolean(submeter));
            if (!commercialAddress?.valid) {
                if (submeter && this.permitirAvancar) {
                    nomeDoCampo = `${commercialAddress?.firstInvalidLabel || 'País'} do Endereço Comercial`;
                }
                this.permitirAvancar = false;
            }

            if (nomeDoCampo != '' && submeter) {
                this.modalAlerta = {
                    mostrar: true,
                    tipo: 'warning',
                    titulo: 'Atenção: Campo obrigatório',
                    mensagem: `O campo ${nomeDoCampo} não foi informado, preencha a informação para avançar.`
                };
            }

            return this.permitirAvancar;
        },
    }
}

</script>
